export * from './ubilogin.component';


// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiLogin/index.ts